import * as PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import {Grid, Typography} from "@material-ui/core";
import GlobalMessages from "../../../messages/messages";
import {FormattedMessage} from "react-intl";
import RefrezhButton from "../../../components/RefrezhButton";
import ConfirmModal from "../../../basicComponents/ConfirmModal/ConfirmModal";
import {useCallback, useState} from "react";

const useStyles = makeStyles(theme => ({


  wrapper: {
    width: "100%",
    padding: "0px 10px 20px 10px",
  },
  borderWrapper: {
    flex: 1,
    borderRadius: "15px",
    border: "1px solid rgba(0,0,0,0.24)",
    width: "100%",
    padding: "15px",
    minWidth: "300px",
    position: "relative",
  },
  divider: {
    width: "100%",
    borderBottom: "1px solid rgba(0,0,0,0.24)",
    margin: "5px 2px 5px 2px"
  },
  button: {
    marginTop: "15px",
    marginLeft: "5px",
    marginRight: "5px",
    overflow: "hidden",
    width: "100%",
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: "300px"
  },
  buttonWrapper: {
    paddingRight: "10px",
  }
}));

export function PlanDataComponent({
  plan,
  onClose,
  onNew,
  title,
  upperProductName,
  lowerProductName,
  buttonPlanName,
  buttonCloseName,
  closeMessage,
  noPlanMessage,
  closeAllowed=false,
  planAllowed=false,
}) {
  const classes = useStyles();

  const [
    showCloseModal,
    setShowCloseModal,
  ] = useState(false);

  const handleClose = useCallback(
    () => {
      setShowCloseModal(true)
    },
    [
      closeAllowed,
      setShowCloseModal,
    ],
  );

  return (
      <div className={classes.wrapper}>
        <ConfirmModal
          onConfirm={()=>{
            onClose()
            setShowCloseModal(false);
          }}
          open={showCloseModal}
          onCancel={()=>{
            setShowCloseModal(false);
          }}
        >
          {closeMessage}
        </ConfirmModal>
        <div className={classes.borderWrapper}>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="h6">
                {title}
              </Typography>
            </Grid>
          </Grid>
          <div className={classes.divider} />
          {plan ? (
            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography variant="caption">
                  <FormattedMessage {...GlobalMessages.orderUpperJaw} />
                </Typography>
                <Typography >
                  {upperProductName || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography variant="caption">
                  <FormattedMessage {...GlobalMessages.orderLowerJaw} />
                </Typography>
                <Typography >
                  {lowerProductName || '-'}
                </Typography>
              </Grid>
            </Grid>):(
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography>
                  {noPlanMessage || '-'}
                </Typography>
              </Grid>
            </Grid>
          )}
          <div className={classes.divider} />
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <div className={classes.buttonWrapper}>
                <RefrezhButton
                  disabled={!planAllowed}
                  className={classes.button}
                  onClick={onNew}
                >
                  {buttonPlanName}
                </RefrezhButton>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <div className={classes.buttonWrapper}>
                <RefrezhButton
                  disabled={!closeAllowed || !plan}
                  className={classes.button}
                  onClick={handleClose}
                >
                  {buttonCloseName}
                </RefrezhButton>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

  );
}

PlanDataComponent.propTypes = {
  plan: PropTypes.object,
  onClose: PropTypes.func,
  onNew: PropTypes.func,
  title: PropTypes.element,
  upperProductName: PropTypes.string,
  lowerProductName: PropTypes.string,
  buttonPlanName: PropTypes.element,
  buttonCloseName: PropTypes.element,
  closeMessage: PropTypes.element,
  noPlanMessage: PropTypes.element,
  closeAllowed: PropTypes.bool,
  planAllowed: PropTypes.bool,
};
